import { UserData } from "@/lib/global/actions";
import { useSelection } from "@frend-digital/centra/client";
import { CustomAdapter, EventSubscription } from "@frend-digital/events/client";
import { depictAdapter } from "@frend-digital/events/depict";
import { BeforeEvent, centraGTMAdapter } from "@frend-digital/events/gtm";
import { useMemo } from "react";
import { md5, utf8_encode } from "./hash";
import { getDepictMarketFromPricelistId } from "../products/[...category]/serverUtils/helpers";

const logAdapter = () =>
  new CustomAdapter((e) => {
    console.log(e.event, e.data);
  });

const Events = () => {
  const { data: selection } = useSelection();

  const adapters = useMemo(() => {
    const beforeGtmEvent: BeforeEvent = async (e) => {
      if (e.event === "purchase") {
        if (window?.ADT?.Tag) {
          /* AdTraction */
          window.ADT.Tag.t = 3;
          window.ADT.Tag.c = e.ecommerce.currency;
          window.ADT.Tag.tp = 1909755022;
          window.ADT.Tag.am = 0;
          if(e.ecommerce.value && e.ecommerce.shipping && e.ecommerce.tax) {
            window.ADT.Tag.am = e.ecommerce.value - e.ecommerce.shipping - e.ecommerce.tax;
          } else if(e.ecommerce.value) {
            window.ADT.Tag.am = e.ecommerce.value;
          }
          window.ADT.Tag.ti = e.ecommerce.transaction_id;
          if (selection?.selection?.address?.email) {
            window.ADT.Tag.xd = md5(
              utf8_encode(selection?.selection?.address?.email),
            );
          }

          window.ADT.Tag.cpn =
            typeof e.ecommerce.coupon === "string"
              ? e.ecommerce.coupon
              : e.ecommerce.coupon || "";
          window.ADT?.Tag?.doEvent();
        }
      }

      const userData: UserData = {};

      const result = {
        ...e,
        ...userData,
      };

      return result;
    };
    return [
      centraGTMAdapter({ beforeEvent: beforeGtmEvent, selection: selection }),
      /*       logAdapter(), */
      depictAdapter("camillapihl", {
        market:
          getDepictMarketFromPricelistId(
            String(selection?.location?.pricelist),
          ) ?? "us",
      }),
    ];
  }, [selection]);

  return <EventSubscription adapters={adapters} />;
};

export default Events;

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
